import {Component} from "@angular/core";
import {ChartSeries} from "../chart-series";
import {AbstractChartComponent, ChartDataPoint, ChartSeriesPointData} from "../abstract-chart.component";
import {Options, SeriesPieOptions} from "highcharts";
import {TranslateService} from "@ngx-translate/core";
import {MeasureDataType} from "../../measure-data-type";
import {DateTimeUtil} from "../../../utils/date-time-util";

@Component({
    selector: "bi-donut-chart",
    templateUrl: "./donut-chart.component.html",
    styleUrls: ["./donut-chart.component.scss"]
})
export class DonutChartComponent extends AbstractChartComponent {

    private showInLegend: boolean;
    private size: string = "100%";

    constructor(translateService: TranslateService) {
        super(translateService);
    }

    defineChart(): Options {
        const chartThis = this;
        return {
            chart: {
                height: this.height,
                marginTop: 5,
                type: "pie",
                events: {
                    // Custom selection handler that selects points and cancels the default zoom behaviour
                    selection: function (e) {
                        // Custom selection handler that selects points and cancels the default zoom behaviour
                        chartThis.drillToSelectionEvent(e);

                        return false; // disable zoom
                    }
                },
                zooming: {
                    type: "xy"
                }
            },
            title: {
                style: {fontSize: "14px", fontWeight: "bold"},
                align: "left",
                x: 30,
                text: this.title
            },
            xAxis: [{
                title: {
                    text: this.xAxisLabel,
                }
            }],
            yAxis: [{
                min: 0,
                title: {
                    text: "",
                },
                plotLines: []
            }],
            legend: {
                align: "right",
                verticalAlign: "bottom",
                y: 0,

                floating: true,
                borderColor: "#CCC",
                itemStyle: {fontWeight: "normal"},
                borderWidth: 0,
                shadow: false
            },
            tooltip: {
                headerFormat: "<b>{point.name}</b><br/>",
                pointFormatter: function () {
                    if (chartThis.seriesDataTypes[this.series.name] === MeasureDataType.SECONDS) {
                        return "<b>" + this.name + "</b><br/>" + this.series.name + ": "  + DateTimeUtil.formatTimeForSeconds(this.y);
                    }
                    return "<b>" + this.name + "</b><br/>" + this.series.name + ": "  + (this.y).toLocaleString();
                }

            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: "pointer",
                    dataLabels: {
                        enabled: false
                    },
                    innerSize: "70%",
                    size: this.size,
                    showInLegend: this.showInLegend
                },
                series: {
                    cursor: "pointer",
                    point: {
                        events: {
                            click: function () {
                                chartThis.selectSingle(this.index);
                                return true;
                            }
                        }
                    }
                }
            },
            credits: {
                enabled: false
            }
        }
    }

    setupData(seriesDataArr: ChartSeries[]): void {
        if (seriesDataArr && seriesDataArr.length > 0) {
            if (this.height >= 400) {
                this.showInLegend = seriesDataArr[0].data.length <= 5;
            } else {
                this.showInLegend = seriesDataArr[0].data.length <= 2;
            }

        }

        if (this.showInLegend) {
            this.size = "80%";
        }
    }

    setupChart(seriesDataArr: ChartSeries[]): void {
        if (seriesDataArr && seriesDataArr.length > 0) {
            if (seriesDataArr[0].dataLabels) {
                this.dataMembers = seriesDataArr[0].dataMembers;
                this.chart.xAxis[0].setCategories(seriesDataArr[0].dataLabels);
            }

            const series: ChartSeriesPointData = new ChartSeriesPointData();
            series.data = [];
            series.name = seriesDataArr[0].name;
            seriesDataArr[0].data.forEach((n: number, index: number) => {
                series.data.push(new ChartDataPoint(seriesDataArr[0].dataLabels[index], n));
            });
            this.chart.addSeries(<SeriesPieOptions> series);
        }
    }
}
